const templateUrl = require('./add-shipping.html');
const ctrl = require('./add-shipping.controller');

module.exports = function($stateProvider) {
  $stateProvider.state('shipping.add', {
    resolve: {
      requiredFields: [
        'formsService',
        formsService => formsService.getRequiredFields().then(data => data.shippingAddress)
      ]
    },
    views: {
      'shipping@': {
        templateUrl: templateUrl,
        controller: ctrl,
        controllerAs: '$ctrl'
      }
    }
  });
};

module.exports.$inject = ['$stateProvider'];
